import {combineReducers} from "redux";

import common from './common-search.reducer'
import forceSearchOptions from './force-options-search.reducer'

export default combineReducers({
    common,
    forceSearchOptions
});
